export const FETCH_BIOMETRIC_DISCREPANCY_REQUEST = 'FETCH_BIOMETRIC_DISCREPANCY_REQUEST';
export const FETCH_BIOMETRIC_DISCREPANCY_SUCCESS = 'FETCH_BIOMETRIC_DISCREPANCY_SUCCESS';
export const FETCH_BIOMETRIC_DISCREPANCY_FAILURE = 'FETCH_BIOMETRIC_DISCREPANCY_FAILURE';

export const FETCH_BIOMETRIC_DEVICE_PUNCH_REQUEST = 'FETCH_BIOMETRIC_DEVICE_PUNCH_REQUEST';
export const FETCH_BIOMETRIC_DEVICE_PUNCH_SUCCESS = 'FETCH_BIOMETRIC_DEVICE_PUNCH_SUCCESS';
export const FETCH_BIOMETRIC_DEVICE_PUNCH_FAILURE = 'FETCH_BIOMETRIC_DEVICE_PUNCH_FAILURE';

export const SAVE_BIOMETRIC_DEVICE_PUNCH_REQUEST = 'SAVE_BIOMETRIC_DEVICE_PUNCH_REQUEST';
export const SAVE_BIOMETRIC_DEVICE_PUNCH_SUCCESS = 'SAVE_BIOMETRIC_DEVICE_PUNCH_SUCCESS';
export const SAVE_BIOMETRIC_DEVICE_PUNCH_FAILURE = 'SAVE_BIOMETRIC_DEVICE_PUNCH_FAILURE';

export const DISCREPANCY_SHIFT_UPDATE_REQUEST = "DISCREPANCY_SHIFT_UPDATE_REQUEST";
export const DISCREPANCY_SHIFT_UPDATE_SUCCESS = "DISCREPANCY_SHIFT_UPDATE_SUCCESS";
export const DISCREPANCY_SHIFT_UPDATE_FAILURE = "DISCREPANCY_SHIFT_UPDATE_FAILURE";

export const DISCREPANCY_PUNCH_UPDATE_REQUEST = "DISCREPANCY_PUNCH_UPDATE_REQUEST";
export const DISCREPANCY_PUNCH_UPDATE_SUCCESS = "DISCREPANCY_PUNCH_UPDATE_SUCCESS";
export const DISCREPANCY_PUNCH_UPDATE_FAILURE = "DISCREPANCY_PUNCH_UPDATE_FAILURE";

export const FETCH_SHIFT_PROCESS_REQUEST = 'FETCH_SHIFT_PROCESS_REQUEST';
export const FETCH_SHIFT_PROCESS_SUCCESS = 'FETCH_SHIFT_PROCESS_SUCCESS';
export const FETCH_SHIFT_PROCESS_FAILURE = 'FETCH_SHIFT_PROCESS_FAILURE';

export const SAVE_SHIFT_PROCESS_REQUEST = 'SAVE_SHIFT_PROCESS_REQUEST';
export const SAVE_SHIFT_PROCESS_SUCCESS = 'SAVE_SHIFT_PROCESS_SUCCESS';
export const SAVE_SHIFT_PROCESS_FAILURE = 'SAVE_SHIFT_PROCESS_FAILURE';

export const FETCH_SHIFT_CHANGE_REQUEST = 'FETCH_SHIFT_CHANGE_REQUEST';
export const FETCH_SHIFT_CHANGE_SUCCESS = 'FETCH_SHIFT_CHANGE_SUCCESS';
export const FETCH_SHIFT_CHANGE_FAILURE = 'FETCH_SHIFT_CHANGE_FAILURE';

export const FETCH_SHIFT_EMPLOYEE_SHIFTCODE_REQUEST = 'FETCH_SHIFT_EMPLOYEE_SHIFTCODE_REQUEST';
export const FETCH_SHIFT_EMPLOYEE_SHIFTCODE_SUCCESS = 'FETCH_SHIFT_EMPLOYEE_SHIFTCODE_SUCCESS';
export const FETCH_SHIFT_EMPLOYEE_SHIFTCODE_FAILURE = 'FETCH_SHIFT_EMPLOYEE_SHIFTCODE_FAILURE';

export const SAVE_SHIFT_CHANGE_REQUEST = 'SAVE_SHIFT_CHANGE_REQUEST';
export const SAVE_SHIFT_CHANGE_SUCCESS = 'SAVE_SHIFT_CHANGE_SUCCESS';
export const SAVE_SHIFT_CHANGE_FAILURE = 'SAVE_SHIFT_CHANGE_FAILURE';

export const FETCH_SHIFT_REMOVE_REQUEST = 'FETCH_SHIFT_REMOVE_REQUEST';
export const FETCH_SHIFT_REMOVE_SUCCESS = 'FETCH_SHIFT_REMOVE_SUCCESS';
export const FETCH_SHIFT_REMOVE_FAILURE = 'FETCH_SHIFT_REMOVE_FAILURE';

export const REMOVE_SHIFT_REQUEST = 'REMOVE_SHIFT_REQUEST';
export const REMOVE_SHIFT_SUCCESS = 'REMOVE_SHIFT_SUCCESS';
export const REMOVE_SHIFT_FAILURE = 'REMOVE_SHIFT_FAILURE';

// 🔹 Punchlist Import
export const PUNCHLIST_GET_TEMPLATE_REQUEST = "PUNCHLIST_GET_TEMPLATE_REQUEST";
export const PUNCHLIST_GET_TEMPLATE_SUCCESS = "PUNCHLIST_GET_TEMPLATE_SUCCESS";
export const PUNCHLIST_GET_TEMPLATE_FAILURE = "PUNCHLIST_GET_TEMPLATE_FAILURE";

export const PUNCHLIST_IMPORT_REQUEST = "PUNCHLIST_IMPORT_REQUEST";
export const PUNCHLIST_IMPORT_SUCCESS = "PUNCHLIST_IMPORT_SUCCESS";
export const PUNCHLIST_IMPORT_FAILURE = "PUNCHLIST_IMPORT_FAILURE";

export const PUNCHLIST_SAVE_REQUEST = "PUNCHLIST_SAVE_REQUEST";
export const PUNCHLIST_SAVE_SUCCESS = "PUNCHLIST_SAVE_SUCCESS";
export const PUNCHLIST_SAVE_FAILURE = "PUNCHLIST_SAVE_FAILURE";

export const FETCH_EMPLOYEE_MOBILE_PUNCH_REQUEST = 'FETCH_EMPLOYEE_MOBILE_PUNCH_REQUEST';
export const FETCH_EMPLOYEE_MOBILE_PUNCH_SUCCESS = 'FETCH_EMPLOYEE_MOBILE_PUNCH_SUCCESS';
export const FETCH_EMPLOYEE_MOBILE_PUNCH_FAILURE = 'FETCH_EMPLOYEE_MOBILE_PUNCH_FAILURE';

export const FETCH_EMPLOYEE_MOBILE_BREAKLISTS_REQUESTS="FETCH_EMPLOYEE_MOBILE_BREAKLISTS_REQUESTS";
export const FETCH_EMPLOYEE_MOBILE_BREAKLISTS_SUCCESS="FETCH_EMPLOYEE_MOBILE_BREAKLISTS_SUCCESS";
export const FETCH_EMPLOYEE_MOBILE_BREAKLISTS_FAILURE="FETCH_EMPLOYEE_MOBILE_BREAKLISTS_FAILURE";

export const SAVE_GENERATED_MOBILE_APPROVAL_REQUEST = 'SAVE_GENERATED_MOBILE_APPROVAL_REQUEST';
export const SAVE_GENERATED_MOBILE_APPROVAL_SUCCESS = 'SAVE_GENERATED_MOBILE_APPROVAL_SUCCESS';
export const SAVE_GENERATED_MOBILE_APPROVAL_FAILURE = 'SAVE_GENERATED_MOBILE_APPROVAL_FAILURE';

export const FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_REQUEST = 'FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_REQUEST';
export const FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_SUCCESS = 'FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_SUCCESS';
export const FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_FAILURE = 'FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_FAILURE';

export const DELETE_MOBILE_PUNCH = "DELETE_MOBILE_PUNCH";
export const DELETE_MOBILE_PUNCH_SUCCESS = "DELETE_MOBILE_PUNCH_SUCCESS";
export const DELETE_MOBILE_PUNCH_FAILURE = "DELETE_MOBILE_PUNCH_FAILURE";

export const RESET_SHIFT_PROCESS = 'RESET_SHIFT_PROCESS';
